// Copyright ©️ 2026 eVolve MEP, LLC

import {
  BendPreviewGeometry,
  type BendPreviewSpecifications,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';

export class Stub90Geometry extends BendPreviewGeometry {
  createBendDefs(dimensions: BendPreviewSpecifications) {
    const { legLength, stubHeight } = dimensions;
    return [
      {
        runLength: legLength,
        endMeasuredTo: 'tubeEdge',
        thenBendBy: Math.PI / 2,
        startLabels: [
          { label: 'Leg Length', length: legLength, offsets: [{ relativeTo: 'bendPlane', offset: 'bottom' }] },
        ],
      },
      {
        runLength: stubHeight,
        startMeasuredFrom: 'tubeEdge',
        startLabels: [
          {
            label: 'Stub Height',
            length: stubHeight,
            offsets: [
              { relativeTo: 'bendPlane', offset: 'backward' },
              { relativeTo: 'bendPlane', offset: 'bottom' },
            ],
          },
        ],
      },
    ] as const;
  }
}
